/** Enfants renvoyés par GET /api/documents/original/:id (ou listes station). */
export function parseConvertedChildrenFromApiResponse(res: any): any[] {
    const data = res?.data ?? res;
    const docs = data?.documents ?? data?.data?.documents;
    if (Array.isArray(docs)) {
        return docs;
    }
    if (Array.isArray(data)) {
        return data;
    }
    return [];
}

function statutIdFromMap(statutIdMap: Record<string, number>, ...keys: string[]): number | null {
    for (const k of keys) {
        const n = Number(statutIdMap[k]);
        if (Number.isFinite(n) && n > 0) {
            return n;
        }
    }
    return null;
}

/**
 * Document source : si une conversion a produit un document destination encore « actif »
 * (ni annulé ni brouillon), on masque Annuler / Remettre en brouillon sur la source.
 */
export function isSourceDocumentLockedByConversion(
    children: any[],
    statutIdMap: Record<string, number>
): boolean {
    if (!Array.isArray(children) || children.length === 0) {
        return false;
    }
    const annuleId = statutIdFromMap(statutIdMap, 'Annulé', 'Annule');
    const brouillonId = statutIdFromMap(statutIdMap, 'Brouillon');

    return children.some((child) => {
        const sid = Number(child?.statut_id ?? child?.statut?.id);
        if (!Number.isFinite(sid) || sid <= 0) {
            return false;
        }
        if (annuleId != null && sid === annuleId) {
            return false;
        }
        if (brouillonId != null && sid === brouillonId) {
            return false;
        }
        return true;
    });
}

export function filterHeaderButtonsWhenConversionLocked<T extends { label?: string }>(
    buttons: T[],
    locked: boolean
): T[] {
    if (!locked) {
        return buttons;
    }
    return buttons.filter((b) => {
        const label = String(b?.label ?? '').trim();
        return label !== 'Annuler' && label !== 'Remettre en brouillon';
    });
}
